export default __webpack_public_path__ + "static/media/oro.60a912b1.png";